import { INTERNAL_USER_AGENTS } from '@repo/config';
import { getClientConfig } from '../configuration/client-instance';
import type { IRequestOptions } from '../types';
import { resolveProviderHeaders } from './resolve-provider-headers';

// Browsers forbid setting user-agent (the header is silently dropped), so the
// fallback is server/worker-only. It matters there: a Worker fetch sends NO
// user-agent unless one is set, and an SDK consumer that never ran
// initializeClient with defaultHeaders (the web sitemap-prewarm cron isolate)
// would otherwise reach the zone as UA-less traffic and be firewall-blocked.
// An explicit UA from defaultHeaders/provider/options always wins.
function hasUserAgent(headers: Record<string, string>): boolean {
  return Object.keys(headers).some((name) => name.toLowerCase() === 'user-agent');
}

function isBrowserRuntime(): boolean {
  return typeof (globalThis as { window?: unknown }).window !== 'undefined';
}

export async function buildHeaders({
  options,
}: {
  options?: IRequestOptions;
}): Promise<Record<string, string>> {
  const config = getClientConfig();
  const providerHeaders = await resolveProviderHeaders(config.headerProvider);
  const headers: Record<string, string> = {
    ...config.defaultHeaders,
    ...providerHeaders,
    ...options?.headers,
  };
  if (!(isBrowserRuntime() || hasUserAgent(headers))) {
    headers['User-Agent'] = INTERNAL_USER_AGENTS.sdk;
  }
  return headers;
}
